/** @jsxImportSource @emotion/react */
import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { customPaginationText } from '../Styles/ProductListingStyles';

const MAX_PAGES_ON_DISPLAY = 5;

interface PaginationProps {
    currentPage: number;
    onUpdatePage(newPage: number): void;
    maxPages: number;
}

const CustomPagination = (props: PaginationProps): JSX.Element => {
    const { currentPage, onUpdatePage, maxPages } = props;

    const renderPaginationItem = (index: number) => {
        return (
            <PaginationItem key={index} active={currentPage === index}>
                <PaginationLink css={customPaginationText} onClick={() => onUpdatePage(index)} style={{ borderRadius: 4, borderColor: '#E6DFD8', backgroundColor: `${currentPage === index ? '#E6DFD8' : 'transparent'}` }}>
                    {index}
                </PaginationLink>
            </PaginationItem>
        );
    };

    const renderPageList = () => {
        let list: Array<JSX.Element> = [];

        for (let i = 1; i <= maxPages; i += 1) {
            list.push(renderPaginationItem(i));
        }

        if (maxPages >= 5) {
            if (currentPage >= 3) {
                if (maxPages - currentPage < 3) {
                    list = list.slice(maxPages - MAX_PAGES_ON_DISPLAY, maxPages);
                } else {
                    list = list.slice((currentPage - 3), (currentPage + 2));
                }
            } else {
                list = list.slice(0, MAX_PAGES_ON_DISPLAY);
            }
        }

        return list;
    };

    const renderBack = () => {
        let disabled = false;

        if (currentPage === 1) disabled = true;

        return (
            <>
                {/* <PaginationItem disabled={disabled}>
                    <PaginationLink css={customPaginationText} first onClick={() => onUpdatePage(1)} />
                </PaginationItem> */}
                <PaginationItem disabled={disabled}>
                    <PaginationLink css={customPaginationText} previous onClick={() => onUpdatePage(currentPage - 1)} style={{ borderRadius: 4, borderColor: '#E6DFD8' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <img src='/assets/icons/ArrowRight.svg' alt='' style={{ transform: 'rotate(180deg)', marginTop: 2 }} />
                            <p>
                                Prev
                            </p>
                        </div>
                    </PaginationLink>
                </PaginationItem>
            </>
        );
    };

    const renderNext = () => {
        let disabled = false;

        if (currentPage === maxPages) disabled = true;

        return (
            <>
                {
                    maxPages > 5 && currentPage <= (maxPages - 4) && (

                        <PaginationItem disabled>
                            <PaginationLink css={customPaginationText} last onClick={() => onUpdatePage(maxPages)} style={{ borderRadius: 4, borderColor: '#E6DFD8' }}>
                                <p style={{ margin: 0 }}>...</p>
                            </PaginationLink>
                        </PaginationItem>
                    )
                }

                {
                    maxPages > 5 && currentPage <= (maxPages - 3) && (

                        <PaginationItem disabled={disabled}>
                            <PaginationLink css={customPaginationText} last onClick={() => onUpdatePage(maxPages)} style={{ borderRadius: 4, borderColor: '#E6DFD8' }}>
                                <p style={{ margin: 0 }}>{maxPages}</p>
                            </PaginationLink>
                        </PaginationItem>
                    )
                }

                <PaginationItem disabled={disabled}>
                    <PaginationLink css={customPaginationText} next onClick={() => onUpdatePage(currentPage + 1)} style={{ borderRadius: 4, borderColor: '#E6DFD8' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <p>
                                Next
                            </p>
                            <img src='/assets/icons/ArrowRight.svg' alt='' />
                        </div>
                    </PaginationLink>
                </PaginationItem>
            </>
        );
    };

    return (
        <Pagination>
            {renderBack()}
            {renderPageList()}
            {renderNext()}
        </Pagination>
    );
};

export default CustomPagination;
